import { Component, EventEmitter, OnInit, OnDestroy, Output, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ISubFrotaModel, IFiltroSubFrotaModel } from '../model/subFrota.model';
import { PesquisaSubfrotaComponent } from '../pesquisa-subfrota/pesquisa-subfrota.component';
import { SubfrotaService } from '../subfrota.service';
import { map, Observable, startWith, debounceTime, distinctUntilChanged, switchMap, of, Subject } from 'rxjs';

interface SubfrotaResponse {
  sucesso: boolean;
  retorno: ISubFrotaModel[];
}

@Component({
  selector: 'app-filtro-subfrota',
  templateUrl: './filtro-subfrota.component.html',
  styleUrls: ['./filtro-subfrota.component.scss'],
  encapsulation: ViewEncapsulation.None,  // <- ESSENCIAL
})
export class FiltroSubfrotaComponent implements OnInit, OnDestroy, OnChanges {
  @Output() onSubfrotaSelected = new EventEmitter<ISubFrotaModel | undefined>();
  @Input() selectedSubFrota?: ISubFrotaModel;
  
  subfrota?: ISubFrotaModel;
  searchControl = { value: '' };
  filteredOptions!: Observable<ISubFrotaModel[]>;
  search$ = new Subject<string>();

  constructor(
    private subfrotaService: SubfrotaService,
    public dialog: MatDialog
  ) {
    this.filteredOptions = this.search$
      .pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(value => {
          if (typeof value === 'string') {
            return this._filter(value || '');
          }
          return of([]);
        })
      );
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.search$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedSubFrota'] && this.selectedSubFrota) {
      this.subfrota = this.selectedSubFrota;
      this.searchControl.value = this.subfrota?.codigo?.toString() || '';
      this.onSubfrotaSelected.emit(this.subfrota);
    }
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.search$.next(input.value);
  }

  private _filter(value: string): Observable<ISubFrotaModel[]> {
    if (!value || value.length < 2) {
      return of([]);
    }

    const filtro = {
      guid: this.subfrotaService.usuario.retorno.guid,
      codFrota: this.subfrotaService.usuario.retorno.codigoEntidade,
      pesquisa: value
    };

    return this.subfrotaService.listFrotaParametro(filtro).pipe(
      map((response: SubfrotaResponse) => response.retorno || [])
    );
  }

  displayFn(subfrota: ISubFrotaModel): string {
    return subfrota && subfrota.codigo ? subfrota.codigo.toString() : '';
  }

  onOptionSelected(event: any): void {
    this.subfrota = event.option.value;
    this.searchControl.value = this.subfrota?.codigo?.toString() || '';
    this.onSubfrotaSelected.emit(this.subfrota);
  }

  onSubmit(): void {
    const dialogRef = this.dialog.open(PesquisaSubfrotaComponent, {
      width: '800px',
      height: '700px',
      data: { codigoFrota: this.subfrotaService.usuario.retorno.codigoEntidade }
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response && response.data) {
        this.subfrota = response.data;
        this.searchControl.value = this.subfrota?.codigo?.toString() || '';
        this.onSubfrotaSelected.emit(this.subfrota);
      }
    });
  }

  limpaFiltro() {
    this.subfrota = undefined;
    this.searchControl.value = '';
    this.onSubfrotaSelected.emit(undefined);
  }
} 